<template>
<span class="ios">
<label class="v-toggle" :class="{'v-toggle--checked': shouldBeChecked, disabled: disabled}">
  <input type="checkbox" :checked="shouldBeChecked" @change="updateInput">
  <span class="v-toggle_handle"></span>
</label>
</span>
</template>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    modelValue: {
      default: false
    },
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    },
    disabled: {
      default: false
    }
    // checked: {
    //   type: Boolean,
    //   default: false,
    // },
    // name: {
    //   type: String,
    // },
  },
  computed: {
    shouldBeChecked() {
      // Note that `true-value` and `false-value` are camelCase in the JS
      return this.modelValue === this.trueValue
    }
  },
  methods: {
    updateInput(event) {
      if (this.disabled) {
        return;
      }
      let isChecked = event.target.checked
      this.$emit('change', isChecked ? this.trueValue : this.falseValue)
    }
  }
}
</script>

<style>
label.v-toggle {
  position: relative;
  display: inline-block;
  height: 21px;
  width: 68px;
  border-radius: 20px;
  box-sizing: border-box;
  background: #e6e6e6;
  border: solid 2px #e6e6e6;
  cursor: pointer;
  vertical-align: middle;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
}

label.v-toggle.disabled {
  cursor: default;
}

label.v-toggle input {
  display: none;
}
label.v-toggle--checked.v-toggle {
  background: #42b983;
  border-color: #42b983;
}
.v-toggle .v-toggle_handle {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;
  background: white;
  border-radius: 100%;
  /* width: 27px;
  height: 27px; */
  width: 17px;
  height: 17px;
  z-index: 1;
  transition: transform 0.3s;
}
.v-toggle--checked .v-toggle_handle {
  transform: translate3d(37px, 0, 0);
}
.v-toggle::before,
.v-toggle::after {
  position: absolute;
  top: 0;
  font-size: 12px;
  line-height: 28px;
}
.v-toggle::before {
  left: 5px;
  content: 'ON';
  color: white;
  opacity: 0;
}
.v-toggle::after {
  right: 5px;
  content: 'OFF';
  color: #666;
}
.v-toggle--checked.v-toggle::before {
  opacity: 1;
}
.v-toggle--checked.v-toggle::after {
  opacity: 0;
}

/** Toggle */
.ios .v-toggle {
  /* width: 51px; */
  width: 33px;
}
.ios .v-toggle--checked.v-toggle {
  /* background: var(--ios-green);
  border-color: var(--ios-green); */
  background: var(--color-green);
  border-color: var(--color-green);
}
.red-toggle.ios .v-toggle--checked.v-toggle {
  background: var(--color-red);
  border-color: var(--color-red);
}
.ios .v-toggle .v-toggle_handle {
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.35), 0 1px 1px rgba(0, 0, 0, 0.15);
}
.ios .v-toggle--checked .v-toggle_handle {
  /* transform: translate3d(20px, 0, 0); */
  transform: translate3d(12px, 0, 0);
}
.ios .v-toggle:before {
  content: '';
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: #e6e6e6;
  transition: opacity 0.3s;
}
.ios .v-toggle--checked:before {
  opacity: 0;
}
.ios .v-toggle:after {
  content: '';
  position: absolute;
  display: block;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 20px;
  transform: scale3d(1, 1, 1);
  transition: transform 0.3s;
}
.ios .v-toggle--checked:after {
  transform: scale3d(0, 0, 0);
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// src/componentsReusable/ToggleSwitchControl.vue